












































































































































































import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
import { clearEmptyAttr } from "@root/utiles/common";
import {
  pagination,
  loadingCatch,
  loading,
  SearchbarControl,
  IsMore
} from "@root/lib/decorator";

const kaReward = namespace("kaReward");
const root = namespace("root");

@Component({})
@pagination("getData", {
  pageSize: 50
})
@SearchbarControl()
@loading()
@IsMore(true)
export default class KaRewardDetail extends Vue {
  @kaReward.Action queryKaFlow: Function;
  @kaReward.Action exportKaFlow: Function;
  @kaReward.Action getFlowDate;
  @root.State ddCodes;

  private dataList: any[] = [];
  private rewardSourceList: any[] = [];
  private transactionTypeList: any[] = [{ label: "KA奖励金提现", value: "1" }];
  gtExportDialog = false;
  exportParams: any = {};

  // 搜索参数
  private form: any = {
    storeName: "",
    createTime: "",
    fundType: [],
    businessType: []
  };

  async created() {
    await this.$dd.register(["BONUS_KA_FUND_TYPE"]).query();
    this.rewardSourceList = this.ddCodes["BONUS_KA_FUND_TYPE"] || [];
  }

  async mounted() {
    Promise.all([this.getData(), this.getUpdateTime()]);
  }
  updateTime: any = "";
  async getUpdateTime() {
    const res: any = await this.getFlowDate();
    this.updateTime = res || "";
  }

  get fundTypeMap() {
    return this.ddCodes.BONUS_KA_FUND_TYPE_MAP || {};
  }

  get searchParams() {
    let { createTime, ...others } = this.form;
    let startDate = undefined;
    let endDate = undefined;
    if (createTime && createTime.length === 2) {
      startDate = createTime[0];
      endDate = createTime[1];
    }
    return {
      ...others,
      startDate,
      endDate
    };
  }

  @loadingCatch
  async getData() {
    const { pageSize, currentPage: pageNum } = this as any;
    try {
      const res = await this.queryKaFlow({
        pageSize,
        pageNum,
        ...this.searchParams
      });
      this.dataList = res.list || [];
      (this as any).total = res.total || 0;
      this.exportParams = { ...this.searchParams };
    } catch (e) {
      console.log(e);
    }
  }
}
